export default "__VITE_ASSET__BOFYTE4a__"